import React, { Dispatch, SetStateAction } from 'react';

import ChevronRightIcon from '@/assets/icons/chevron-right.svg';

import { CategoryCount } from '../../../helpers/floor-plan/floor-plan-helpers';
import { ClickHistory } from '../../floor-plan/floor-plan';
import { FloorPlanFilterListType } from '../floor-plan-filter-list-type.type';

interface FloorPlanFilterCategoriesProps {
  categories?: CategoryCount;
  filterByCategory?: (category: string, type?: FloorPlanFilterListType) => void;
  type?: FloorPlanFilterListType;
  setClickHistory: Dispatch<SetStateAction<ClickHistory[]>>;
  clickHistory: ClickHistory[];
}
export const FloorPlanFilterCategories = ({
  categories,
  filterByCategory,
  type,
  setClickHistory,
  clickHistory,
}: FloorPlanFilterCategoriesProps) => {
  const Category = ({
    category,
    setClickHistory,
    clickHistory,
  }: {
    category: string;
    setClickHistory: Dispatch<SetStateAction<ClickHistory[]>>;
    clickHistory: ClickHistory[];
  }) => {
    const handleOnClick = () => {
      filterByCategory?.(category, type);
      if (clickHistory && type)
        setClickHistory([...clickHistory, { title: category, type }]);
    };
    return (
      <button
        type="button"
        tabIndex={0}
        className="my-1 mr-3 flex w-full cursor-pointer items-center justify-between rounded-xl bg-brand-white p-5 text-bodyl text-icon-dark md:active:bg-background-secondary lg:hover:bg-background-secondary"
        onClick={handleOnClick}
      >
        {category}
        <ChevronRightIcon />
      </button>
    );
  };
  if (!categories) return null;

  const categoryList = [];
  for (const [key, value] of Object.entries(categories)) {
    categoryList.push({ name: key, count: value });
  }
  return (
    <>
      {categoryList
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((category, index) => (
          <Category
            key={`${category.name}-${category.count}-${index}`}
            category={category.name}
            clickHistory={clickHistory}
            setClickHistory={setClickHistory}
          />
        ))}
    </>
  );
};
